import useAuthStore from '../AuthStore';

/** Helper to pull current authentication status from store */
const getIsAuthenticated = () => useAuthStore.getState().isAuthenticated;

export default getIsAuthenticated;
